export const randomCoverPic = 'https://picsum.photos/1500/500';

export const randomProfilePic = 'https://picsum.photos/400/400';